<template>
  <div class="signUp_page">
    <div class="singnUp_title">
      <div class="name">报名信息</div>
    </div>
    <div class="information">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专业要求" prop="categoryNo" label-width="79px">
              <el-input v-model="form.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地区" prop="Address" label-width="120px">
              <el-cascader
                ref="startPlace"
                v-model="form.Address"
                :options="rengionThreeList"
                :props="propsType"
                clearable
                placeholder="请选择所在地区"
                @change="handleChangeAddressGetLng"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="拥有工种" prop="workType" label-width="79px">
              <el-select
                :multiple-limit="20"
                multiple
                v-model="form.workType"
                clearable
                placeholder="请选择工种,最多可选20个"
              >
                <el-option
                  v-for="(item, index) in workType"
                  :key="index"
                  :label="item.name"
                  :value="item.no"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="施工人数" prop="constructionNumber" label-width="120px">
              <el-input
                v-model="form.constructionNumber"
                placeholder="请输入用工人数 单位:人"
                maxlength="3"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人" prop="contact" label-width="79px" style="text-align: left">
              <el-input
                v-model="form.contact"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" prop="contactPhone" label-width="120px">
              <el-input
                v-model="form.contactPhone"
                placeholder="请输入联系电话"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="用工类型:" prop="employmentType">
              <el-select
                v-model="form.employmentType"
                clearable
                placeholder="请选择用工类型"
              >
                <el-option
                  v-for="(item, index) in types"
                  :key="index"
                  :label="item.desc"
                  :value="item.type"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row>
          <!-- <el-col :span="12">
            <el-form-item label="联系电话:" prop="contactPhone">
              <el-input
                v-model="form.contactPhone"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="24" class="phone"> 
            <el-form-item label="短信验证码" prop="code" label-width="93px" style="margin-left:-14px">
              <el-input
                v-model="form.code"
                placeholder="请输入短信验证码"
                maxlength="6"
              ></el-input>
            </el-form-item>
            <el-button
              :disabled="isDisabled"
              @click="getVerificationCode"
              type="primary"
            >
              {{ buttonName }}
            </el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="protocolbox">
        <el-checkbox v-model="checked">
          <span> 您确认阅读并接受 </span>
        </el-checkbox>
        <span class="xy">
          <a @click.stop="readProtocol">《经营帮用户协议》</a>
        </span>
      </div>
      <div class="tips">{{ tips }}</div>
      <div class="signUp_btn">
        <el-button class="cancel" @click="cancel" style="marginRight:10px">取 消</el-button>
        <el-button class="enroll" v-if="loginType" type="primary" @click="confirm('form')">
          报名
        </el-button>
        <el-button class="enrolls" v-else type="primary" @click="confirm('form')">
          报名并注册
        </el-button>
      </div>
    </div>

    <!-- <div class="signUp_tab">
      <el-tabs v-model="activename" @tab-click="handleClick" id="pane">
        <el-tab-pane label="用工详情" activeIndex="0">
          <signUpDetail :Detail="Detail"></signUpDetail>
        </el-tab-pane>
        <el-tab-pane label="用工说明" activeIndex="1">
          <signUpexplain :Detail="Detail"></signUpexplain>
        </el-tab-pane>
        <el-tab-pane label="报名列表" activeIndex="2">
          <signUpTableList
            :data="tableData"
            :loadingTrue="loadingTrue"
          ></signUpTableList>
          <Pagination
            :isList="true"
            :param="params"
            @change="getSignUpList"
            v-if="tableData.length > 0"
            :loadingTrue="loadingTrue"
          ></Pagination>
        </el-tab-pane>
      </el-tabs>
    </div> -->
    <agreeMent :onOff.sync="dialogVisible"></agreeMent>
  </div>
</template>

<script>
import { apiFlexibleEmployment } from "@/api/apiFlexibleEmployment"
import localStorage from "@/storage/localStorage"
import { validator } from "@/utils/validator"
import { mapState } from "vuex"
export default {
  data() {
    return {
      activename: "0",
      isDisabled: false,
      loadingTrue: false,
      tips: "注：请务必查看确认用工详情，方便及时解决用工问题！",
      checked: false,
      dialogVisible: false,
      buttonName: "获取短信验证码",
      time: 60,
      issend: true,
      rengionThreeList: [], // 所在地区
      optionsRange: [],
      changeSelect: null, // 拥有工种筛选
      /** @name 拥有工种配置 */
      props: {
        multiple: true,
        expandTrigger: "hover",
        checkStrictly: true,
        value: "no",
        label: "name"
      },
      /** @name 地区配置 */
      propsType: { expandTrigger: "hover", label: "name", value: "no" },
      form: {
        name: "",
        industryNo: "",
        categoryNo: "",
        Address: "",
        code: "",
        provinceNo: "",
        provinceName: "",
        cityNo: "",
        cityName: "",
        areaNo: "",
        areaName: "",
        workType: "",
        constructionNumber: "",
        contact: "",
        employmentType: null,
        contactPhone: "",
        relationNo: "" // 报名的数据no值
      },
      params: {
        page: 1,
        limit: 20,
        relationNo: "",
        type: 2
      },
      category: [], // 专业类型
      workType: [], // 拥有工种
      types: [], // 用工类型
      Detail: {}, // 详情
      tableData: [], // 报名列表
      rules: {
        categoryNo: [
          {
            required: true,
            trigger: "blur",
            message: "请选择专业要求"
          }
        ],
        Address: [
          {
            required: true,
            trigger: "change",
            message: "请选择所在地区"
          }
        ],
        workType: [
          { required: true, message: "请选择工种，最多可选20个", trigger: "change" }
        ],
        constructionNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入用工人数"
          },
          {pattern:/^\+?[1-9]{1}[0-9]{0,2}\d{0,0}$/,message:'只能输入范围为1-999的数字'}
        ],
        contact: [
          {
            required: true,
            trigger: "blur",
            message: "请输入联系人"
          }
        ],
        employmentType: [
          {
            required: true,
            trigger: "blur",
            validator: validator.checkNullValue
          }
        ],
        contactPhone: [
          { required: true, trigger: "blur", validator: validator.checkPhone }
        ],
        code: [
          {
            required: true,
            trigger: "blur",
            message: "请输入短信验证码"
          },
          {pattern:/^\d{6}$/,message:'请输入正确短信验证码'}
        ]
      }
    }
  },

  components: {
    agreeMent: () => import("./components/agreeMent.vue")
    // signUpDetail: () => import('./signUpDetail.vue'), // 用工详情
    // signUpexplain: () => import('./signUpexplain.vue'), // 用工说明
    // signUpTableList: () => import('./signUpTableList.vue'), // 报名列表
    // Pagination: () => import('@/views/Construction/components/Pagination') // 分页
  },
  created() {
    this.$nextTick(() => {
      this.$refs.form && this.$refs.form.resetFields();
    })
    if (this.$route.query) {
      this.form.relationNo = this.$route.query.no
      this.form.categoryNo = this.$route.query.categoryNo
      this.form.industryNo = this.$route.query.industryNo
      this.form.createUser = this.$route.query.createUser
      this.form.name =
        this.$route.query.industryName + "/" + this.$route.query.categoryName
      this.getDetail(this.$route.query.no)
      this.getSignUpList()
      // this.GetClassification(); //获取分类
      this.GetNewWorkType() // 获取工种
    }
    this.getTypeAndStatus() // 获取下拉框数据
    this.initData() // 获取所在地区
  },
  mounted() {
    // if (this.loginType) {
    //   this.form.contact = this.user.realName;
    //   this.form.contactPhone = this.user.accountName;
    // } else {
    //   this.form.contact = "";
    //   this.form.contactPhone = "";
    // }
  },
  computed: {
    ...mapState({
      user: state => state.user,
      loginType: state => state.loginType
    })
  },
  watch: {
    optionsRange: {
      handler(newVal) {
        newVal.map(items => {
          items.value = items.no
          items.label = items.name
          if (items.children && items.children.length > 0) {
            items.children.map(item => {
              item.value = item.no
              item.label = item.name
            })
          }
        })
      },

      deep: true // true 深度监听
    },
    loginType: {
      handler(val) {
        if (val && this.user.realName) {
          this.form.contact = this.user.realName
          this.form.contactPhone = this.user.telPhone
        } else {
          this.form.contact = ""
          this.form.contactPhone = ""
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleClick(tab) {},
    /** @name 获取联动-分类 */
    async GetNewWorkType() {
      let categoryNo = this.$route.query.categoryNo
      let res = await apiFlexibleEmployment.GetNewWorkType(categoryNo)
      this.workType = res.data.data
      this.optionsRange = res.data.data
    },
    /** @name 获取所在地区 */
    async initData() {
      let res = await apiFlexibleEmployment.getLocation()
      if (res && res.data && res.data.code === 200) {
        this.rengionThreeList = JSON.parse(JSON.stringify(res.data.data.data))
      }
    },
    /** @name 获取下拉数据 */
    async getTypeAndStatus() {
      let res = await apiFlexibleEmployment.GetTypeAndStatus()
      this.category = res.data.data.category
      // this.workType = res.data.data.workType
      // this.optionsRange = res.data.data.workType;
      this.types = res.data.data.type
    },
    /** @name 筛选拥有工种 */
    handleChange(value) {
      this.form.workType = []
      for (let i = 0; i < value.length; i++) {
        this.form.workType = this.form.workType.concat(value[i])
      }
      if (this.form.workType.length >= 20) {
        this.isDisabled = true
      }
    },
    /** @name 获取地区参数 */
    handleChangeAddressGetLng(value) {
      if (value) {
        let addres = this.$refs["startPlace"].getCheckedNodes()[0].pathLabels
        this.form.provinceNo = value[0]
        this.form.cityNo = value[1]
        this.form.areaNo = value[2]
        this.form.provinceName = addres[0]
        this.form.cityName = addres[1]
        this.form.areaName = addres[2]
      }
    },
    /** @name 判断15分钟内是否有发送过验证码 */
    isSends() {
      let time = localStorage.read("isLosePassword" + this.form.contactPhone)
      let timeInitialize = 15 * 60
      let timeDifference = (Number(new Date()) - time) / 1000
      if (timeDifference < timeInitialize) {
        this.isSend = false
      } else {
        localStorage.clear("isLosePassword" + this.form.contactPhone)
        this.isSend = true
      }
    },
    /** @name 获取短信验证码 */
    async getVerificationCode() {
      if (this.form.contactPhone === "") {
        this.$_toast({ type: "error", msg: "请输入手机号！" })
        return
      }
      if (
        this.form.contactPhone !== "" &&
        this.form.contactPhone.length !== 11
      ) {
        this.$_toast({ type: "error", msg: "请输入正确手机号！" })
        return
      }
      this.isDisabled = true

      let tel = this.form.contactPhone
      let result = await apiFlexibleEmployment.sendCodeOldTel(tel)
      if (result.data.code === 200) {
        let time = new Date()
        localStorage.set(
          "isLosePassword" + this.form.contactPhone,
          Number(time)
        )
        this.issend = true

        this.$_toast({ msg: "验证码已发送到您的手机，请查收" })
        let me = this
        let interval = window.setInterval(function() {
          me.buttonName = me.time + "秒后重新发送"
          --me.time
          if (me.time < 0) {
            me.buttonName = "获取短信验证码"
            me.time = 60
            me.isDisabled = false
            window.clearInterval(interval)
          }
        }, 1000)
      } else {
        this.$_toast({ type: "error", msg: result.data.msg })
        this.isDisabled = false
      }
    },
    /** @name 点击用户协议 */
    readProtocol() {
      this.checked = true
      this.dialogVisible = true
    },
    /** @name 获取用工详情 */
    async getDetail(no) {
      let res = await apiFlexibleEmployment.GetDetail(no)
      this.Detail = res.data.data

    },
    /** @name 获取报名列表 */
    async getSignUpList() {
      this.params.relationNo = this.$route.query.no
      this.loadingTrue = true
      let res = await apiFlexibleEmployment.GetSignUpList(this.params)

      this.tableData = res.data.data.records
      this.loadingTrue = false
      this.$set(this.params, "total", res.data.data.total)
    },
    open() {
      this.$alert("您的初始密码是: 123456Abc!", "报名并注册成功", {
        confirmButtonText: "确定"
        // callback: action => {
        //   this.$message({
        //     type: 'info',
        //     message: `action: ${ action }`
        //   });
        // }
      })
    },
    /** @name 提交并注册 */
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (!this.checked) {
            this.$message.error("请阅读《经营帮用户协议》并确认");
            return;
          }
          apiFlexibleEmployment
            .addForm(this.form)
            .then(res => {
              if (res.code === 500) {
                this.$message.error(res.msg || "报名失败")
              }else{
                if (res.data.code === 200) {
                  this.$message.success("报名成功")
                  this.form = {}
                  this.form.categoryNo = this.$route.query.categoryNo
                  this.form.industryNo = this.$route.query.industryNo
                  this.$router.go(-1)
                  if (res.data.data === false) {
                    this.open()
                  }
                } else {
                  //this.form = {}
                  this.$message.warning(res.data.msg)
                }
              }

            })
            .catch(err => {

            })
        }
      })
    },
    /** @name 取消 */
    cancel() {
      this.form = {}
      this.$router.push({
        path: "/FlexibleDetail",
        query: {
          no: this.$route.query.no
        }
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
div {
  box-sizing: border-box;
}
/deep/ .el-icon-circle-close{
  color:#999 !important;
}
/deep/.el-form-item__error {
  padding-top: 0px;
}
.signUp_page{
  /deep/.el-input__inner{
    height: 34px!important;
    line-height: 34px!important;
    color: #000;
    padding: 0 10px;
  }
  /deep/.el-form-item__label{
    height: 34px!important;
    line-height: 34px!important;
    text-align: right;
    padding: 0 10px 0 0;
  }
  /deep/.el-form-item__content{
    height: 34px!important;
    line-height: 34px!important;
  }
  .el-form-item{
    margin-bottom: 15px!important;
  }
}
.signUp_page {
  padding: 10px 0;
  width: 1200px;
  margin: 0 auto;
  font-size: 14px;
  .singnUp_title {
    padding: 10px 10px;
    background-color: #fff;
    .name {
      font-size: 18px;
      font-weight: 400;
      line-height: 23px;
      border-left: 3px solid #b79255;
      padding-left: 10px;
      color: #b79255;
    }
  }
  .information {
    background: #fff;
    color: #000;
    padding: 0 0 20px 20px ;
    .signUp_btn {
      width: 14%;
      margin: 0 auto;
      .cancel{
        width: 58px;
        height: 34px;
        padding: 0;
        color: #969696;
        border-color: #E4E7ED;
        &:hover{
          background: #fff;
          color: #969696;
          border-color: #E4E7ED;
        }
      }
      .enroll{
        width: 58px;
        height: 34px;
        padding: 0;
        &:hover{
          background: #b79255;       
          border-color: #b79255;       
        }
      }
      .enrolls{
        width: 87px;
        height: 34px;
        padding: 0;
        &:hover{
          background: #b79255;       
          border-color: #b79255;       
        }
      }
    }
  }
  .protocolbox {
    margin-left: 10px;
    margin-bottom: 10px;
    .xy {
      a {
        color: #b79255;
        cursor: pointer;
      }
    }
  }
  .tips {
    color: #ff6600;
    font-size: 14px;
    margin-left: 10px;
    padding-bottom: 20px;
  }
  .signUp_tab {
    margin-top: 10px;
    background-color: #fff;
    .signUp_btn {
      width: 25%;
      margin: 0 auto;
      padding: 20px;
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>
<style lang="scss">
.signUp_page {
  .el-select {
    width: 450px;
    height: 34px!important;
    line-height: 34px!important;
  }
  .el-cascader {
    width: 450px;
    height: 34px!important;
    line-height: 34px!important;
  }
  .el-input {
    width: 450px;
    height: 34px!important;
    line-height: 34px!important;
  }
  .phone {
    display: flex;
    .el-input {
      width: 309px;
    }
    .el-button {
      height: 34px;
      line-height: 34px;
      padding: 0 10px;
      margin-left: 20px;
      color: #b79255;
      background-color: #fff;
      border-color: #b79255;
    }
  }
  .el-tabs__item {
    height: 50px;
    line-height: 50px;
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    padding-left: 20px;
  }
}
</style>
<style lang="scss">
.information {
  .el-button--primary {
    color: #fff;
    background-color: #b79255;
    border-color: #b79255;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333333;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #b79255;
    border-color: #b79255;
  }
  .el-checkbox__inner:hover {
    border-color: #b79255;
  }
}
</style>
